module.exports = __webpack_public_path__ + "static/media/info-icon.b6c086c8.svg";